export type DeploymentInfo = {
  version: string;
  commit: string;
  builtAt?: string;
};

function formatDeploymentDate(value?: string) {
  if (!value) return null;
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return null;
  const parts = new Intl.DateTimeFormat("fr-FR", {
    timeZone: "Europe/Luxembourg",
    day: "2-digit",
    month: "2-digit",
    year: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  }).formatToParts(date);
  const part = (type: Intl.DateTimeFormatPartTypes) => parts.find((item) => item.type === type)?.value ?? "";
  return `${part("day")}/${part("month")}/${part("year")} ${part("hour")}:${part("minute")}`;
}

export function DeploymentVersion({ version, commit, builtAt }: DeploymentInfo) {
  const shortCommit = commit === "local" ? commit : commit.slice(0, 12);
  const deployedAt = formatDeploymentDate(builtAt);
  const label = commit === "local"
    ? `Version locale ${version}`
    : `Version déployée ${version}, commit ${shortCommit}${deployedAt ? `, le ${deployedAt}` : ""}`;

  return (
    <p className="ensemble-deployment-version" aria-label={label} title={label}>
      <span className="ensemble-deployment-version-long">Version {version}</span>
      <span className="ensemble-deployment-version-short">v{version}</span>
      <span aria-hidden="true">·</span>
      <code>{shortCommit}</code>
      {deployedAt && <><span aria-hidden="true">·</span><time dateTime={builtAt}>{deployedAt}</time></>}
    </p>
  );
}
